/**
 * Fires a Google Ads Click-to-Call conversion event and then navigates to the given URL.
 * Also pushes a 'phone_click' event into the dataLayer for GTM/GA4.
 * Falls back to direct navigation if gtag_report_conversion is not yet loaded.
 */
export const trackPhoneConversion = (url: string, location: string = 'header'): void => {
  // dataLayer-Push für GTM/GA4
  (window as any).dataLayer = (window as any).dataLayer || [];
  (window as any).dataLayer.push({
    event: 'phone_click',
    cta_location: location,
  });

  // Bestehender Google Ads Conversion-Aufruf bleibt
  if (typeof (window as any).gtag_report_conversion === 'function') {
    (window as any).gtag_report_conversion(url);
  } else {
    window.location.href = url;
  }
};
